import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import RegionFormLayer from "../components/RegionFormLayer";

const RegionFormPage = () => {
    return (
        <MasterLayout>
            <RegionFormLayer />
        </MasterLayout>
    );
};

export default RegionFormPage;
